import { IconProps } from "@/src/sb/business-layer/types"
import React from "react"

const GenericSearchIcon = ({ width, height, size }: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width ?? size ?? 12}
    height={height ?? size ?? 12}
    viewBox="0 0 12 12"
    fill="none"
  >
    <path
      d="M10.5 1.5C10.9142 1.5 11.25 1.83579 11.25 2.25V9.75C11.25 10.1642 10.9142 10.5 10.5 10.5H1.5C1.08579 10.5 0.75 10.1642 0.75 9.75V2.25C0.75 1.83579 1.08579 1.5 1.5 1.5H10.5ZM1.5 9.75H10.5V3.75H1.5V9.75ZM7.875 7.875H3V7.125H7.875V7.875ZM7.125 6H3V5.25H7.125V6ZM1.5 3H10.5V2.25H1.5V3Z"
      fill="currentColor"
    />
  </svg>
)

export default GenericSearchIcon
